var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFramingLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4, .cls-5, .cls-6 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5, .cls-6 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 0.33px;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.67px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.47px;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke-width: 0.8px;\r\n      }\r\n\r\n      .cls-7 {\r\n        font-size: 8.79px;\r\n        font-family: ArialMT, Arial;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconFramingLayer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Framing"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "63.42 136.87 63.42 134.32 59.16 132.78 59.16 117.14 63.42 118.67 63.42 116.13 53.67 112.62 53.67 115.17 57.93 116.7 57.93 132.34 53.67 130.81 53.67 133.36 63.42 136.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "63.42 134.32 125.92 99.3 121.66 97.77 59.16 132.78 63.42 134.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.16 132.78 121.66 97.77 121.66 86.04 63.42 118.67 59.16 117.14 59.16 118.67 59.16 132.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "63.42 118.67 125.92 83.66 125.92 81.11 63.42 116.13 63.42 118.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "63.42 116.13 125.92 81.11 116.17 77.6 53.67 112.62 63.42 116.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "57.93 132.34 57.93 128.43 53.67 130.81 57.93 132.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "63.42 136.87 125.92 101.85 125.92 99.3 63.42 134.32 63.42 136.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.43 122.83 24.43 120.28 20.17 118.75 20.17 103.11 24.43 104.64 24.43 102.09 19.56 100.34 19.56 121.08 24.43 122.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.43 120.28 86.93 85.27 82.68 83.73 20.17 118.75 24.43 120.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "20.17 118.75 82.68 83.73 82.68 72.01 24.43 104.64 20.17 103.11 20.17 104.64 20.17 118.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.43 104.64 86.93 69.62 86.93 67.08 24.43 102.09 24.43 104.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.43 102.09 86.93 67.08 82.06 65.32 19.56 100.34 24.43 102.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.43 122.83 86.93 87.82 86.93 85.27 24.43 120.28 24.43 122.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.53 149.15 97.53 128.41 92.66 126.65 92.66 129.2 96.91 130.73 96.91 146.38 92.66 144.84 92.66 147.39 97.53 149.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "96.91 146.38 96.91 142.46 92.66 144.84 96.91 146.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.53 128.41 160.03 93.39 155.16 91.64 92.66 126.65 97.53 128.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.53 149.15 160.03 114.13 160.03 93.39 97.53 128.41 97.53 148.35 97.53 149.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "160.03 96.51 160.03 100.42 160.03 114.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 97.53,
    y1: 149.15,
    x2: 160.03,
    y2: 114.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 164.91,
    y1: 115.88,
    x2: 163.08,
    y2: 115.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 161.86,
    y1: 114.79,
    x2: 160.03,
    y2: 114.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.56,
    y1: 114.04,
    x2: 18.94,
    y2: 114.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 160.03,
    y1: 93.39,
    x2: 160.03,
    y2: 96.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.42,
    y1: 134.32,
    x2: 59.16,
    y2: 132.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 59.16,
    y1: 132.79,
    x2: 59.16,
    y2: 117.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 59.16,
    y1: 117.14,
    x2: 63.42,
    y2: 118.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.42,
    y1: 118.67,
    x2: 63.42,
    y2: 116.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.42,
    y1: 116.12,
    x2: 53.67,
    y2: 112.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.67,
    y1: 112.62,
    x2: 53.67,
    y2: 115.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.67,
    y1: 115.16,
    x2: 57.93,
    y2: 116.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 57.93,
    y1: 116.7,
    x2: 57.93,
    y2: 132.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 57.93,
    y1: 132.34,
    x2: 53.67,
    y2: 130.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.67,
    y1: 130.81,
    x2: 53.67,
    y2: 133.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.67,
    y1: 133.36,
    x2: 63.42,
    y2: 136.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.42,
    y1: 136.87,
    x2: 63.42,
    y2: 134.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.92,
    y1: 99.3,
    x2: 125.92,
    y2: 101.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.17,
    y1: 77.6,
    x2: 125.92,
    y2: 81.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.92,
    y1: 81.11,
    x2: 125.92,
    y2: 83.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 121.66,
    y1: 86.04,
    x2: 121.66,
    y2: 97.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 121.66,
    y1: 97.77,
    x2: 125.92,
    y2: 99.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.42,
    y1: 134.32,
    x2: 125.92,
    y2: 99.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 121.66,
    y1: 97.77,
    x2: 59.16,
    y2: 132.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.92,
    y1: 83.66,
    x2: 63.42,
    y2: 118.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.92,
    y1: 81.11,
    x2: 63.42,
    y2: 116.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.17,
    y1: 77.6,
    x2: 53.67,
    y2: 112.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 57.93,
    y1: 128.42,
    x2: 53.67,
    y2: 130.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.92,
    y1: 101.85,
    x2: 63.42,
    y2: 136.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 24.43,
    y1: 120.28,
    x2: 20.17,
    y2: 118.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.17,
    y1: 118.75,
    x2: 20.17,
    y2: 103.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.17,
    y1: 103.11,
    x2: 24.43,
    y2: 104.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 24.43,
    y1: 104.64,
    x2: 24.43,
    y2: 102.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 24.43,
    y1: 102.09,
    x2: 19.56,
    y2: 100.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.56,
    y1: 100.34,
    x2: 19.56,
    y2: 121.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.56,
    y1: 121.08,
    x2: 24.43,
    y2: 122.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 24.43,
    y1: 122.83,
    x2: 24.43,
    y2: 120.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 86.93,
    y1: 85.27,
    x2: 86.93,
    y2: 87.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.06,
    y1: 65.32,
    x2: 86.93,
    y2: 67.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 86.93,
    y1: 67.07,
    x2: 86.93,
    y2: 69.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.68,
    y1: 72.01,
    x2: 82.68,
    y2: 83.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.68,
    y1: 83.74,
    x2: 86.93,
    y2: 85.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 24.43,
    y1: 120.28,
    x2: 86.93,
    y2: 85.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.68,
    y1: 83.74,
    x2: 20.17,
    y2: 118.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 86.93,
    y1: 69.62,
    x2: 24.43,
    y2: 104.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 86.93,
    y1: 67.07,
    x2: 24.43,
    y2: 102.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.06,
    y1: 65.32,
    x2: 19.56,
    y2: 100.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 86.93,
    y1: 87.82,
    x2: 24.43,
    y2: 122.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 92.66,
    y1: 144.84,
    x2: 92.66,
    y2: 147.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 92.66,
    y1: 147.39,
    x2: 97.53,
    y2: 149.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 97.53,
    y1: 149.15,
    x2: 97.53,
    y2: 128.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 97.53,
    y1: 128.4,
    x2: 92.66,
    y2: 126.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 92.66,
    y1: 126.65,
    x2: 92.66,
    y2: 129.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 92.66,
    y1: 129.2,
    x2: 96.91,
    y2: 130.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 96.91,
    y1: 130.73,
    x2: 96.91,
    y2: 146.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 96.91,
    y1: 146.38,
    x2: 92.66,
    y2: 144.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 155.16,
    y1: 91.63,
    x2: 160.03,
    y2: 93.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 96.91,
    y1: 142.46,
    x2: 92.66,
    y2: 144.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 92.66,
    y1: 126.65,
    x2: 155.16,
    y2: 91.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 97.53,
    y1: 128.4,
    x2: 160.03,
    y2: 93.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 102.4,
    y1: 148.35,
    x2: 100.88,
    y2: 147.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 99.67,
    y1: 147.37,
    x2: 98.15,
    y2: 146.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 98.15,
    y1: 146.82,
    x2: 98.15,
    y2: 144.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 98.15,
    y1: 143.18,
    x2: 98.15,
    y2: 141.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 98.15,
    y1: 139.93,
    x2: 98.15,
    y2: 138.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 98.15,
    y1: 136.67,
    x2: 98.15,
    y2: 134.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 98.15,
    y1: 133.42,
    x2: 98.15,
    y2: 131.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 98.15,
    y1: 131.18,
    x2: 99.67,
    y2: 131.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 100.88,
    y1: 132.16,
    x2: 102.4,
    y2: 132.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 102.4,
    y1: 132.71,
    x2: 102.4,
    y2: 130.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 102.4,
    y1: 130.16,
    x2: 100.58,
    y2: 129.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 99.36,
    y1: 129.06,
    x2: 97.53,
    y2: 128.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 97.53,
    y1: 149.15,
    x2: 99.36,
    y2: 149.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 100.58,
    y1: 150.24,
    x2: 102.4,
    y2: 150.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 102.4,
    y1: 150.9,
    x2: 102.4,
    y2: 148.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 164.91,
    y1: 113.34,
    x2: 164.91,
    y2: 115.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 160.03,
    y1: 93.39,
    x2: 161.86,
    y2: 94.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 163.08,
    y1: 94.49,
    x2: 164.91,
    y2: 95.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 164.91,
    y1: 95.14,
    x2: 164.91,
    y2: 97.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 160.65,
    y1: 100.08,
    x2: 160.65,
    y2: 101.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 160.65,
    y1: 103.38,
    x2: 160.65,
    y2: 105.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 160.65,
    y1: 106.64,
    x2: 160.65,
    y2: 108.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 160.65,
    y1: 109.89,
    x2: 160.65,
    y2: 111.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 160.65,
    y1: 111.8,
    x2: 162.17,
    y2: 112.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 163.39,
    y1: 112.79,
    x2: 164.91,
    y2: 113.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 102.4,
    y1: 148.35,
    x2: 103.54,
    y2: 147.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 104.52,
    y1: 147.17,
    x2: 105.82,
    y2: 146.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 106.8,
    y1: 145.89,
    x2: 108.1,
    y2: 145.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 109.08,
    y1: 144.61,
    x2: 110.38,
    y2: 143.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 111.36,
    y1: 143.34,
    x2: 112.66,
    y2: 142.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 113.63,
    y1: 142.06,
    x2: 114.94,
    y2: 141.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 115.91,
    y1: 140.78,
    x2: 117.21,
    y2: 140.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 118.19,
    y1: 139.51,
    x2: 119.49,
    y2: 138.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 120.47,
    y1: 138.23,
    x2: 121.77,
    y2: 137.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 122.75,
    y1: 136.95,
    x2: 124.05,
    y2: 136.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.03,
    y1: 135.68,
    x2: 126.33,
    y2: 134.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 127.31,
    y1: 134.4,
    x2: 128.61,
    y2: 133.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.59,
    y1: 133.12,
    x2: 130.89,
    y2: 132.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 131.86,
    y1: 131.85,
    x2: 133.17,
    y2: 131.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 134.14,
    y1: 130.57,
    x2: 135.45,
    y2: 129.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 136.42,
    y1: 129.29,
    x2: 137.72,
    y2: 128.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 138.7,
    y1: 128.02,
    x2: 140,
    y2: 127.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 140.98,
    y1: 126.74,
    x2: 142.28,
    y2: 126.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 143.26,
    y1: 125.46,
    x2: 144.56,
    y2: 124.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 145.54,
    y1: 124.19,
    x2: 146.84,
    y2: 123.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 147.82,
    y1: 122.91,
    x2: 149.12,
    y2: 122.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 150.09,
    y1: 121.63,
    x2: 151.4,
    y2: 120.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 152.37,
    y1: 120.36,
    x2: 153.68,
    y2: 119.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 154.65,
    y1: 119.08,
    x2: 155.95,
    y2: 118.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 156.93,
    y1: 117.8,
    x2: 158.23,
    y2: 117.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 159.21,
    y1: 116.53,
    x2: 160.51,
    y2: 115.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 161.49,
    y1: 115.25,
    x2: 162.79,
    y2: 114.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 163.77,
    y1: 113.97,
    x2: 164.91,
    y2: 113.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 160.65,
    y1: 111.8,
    x2: 159.51,
    y2: 112.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 158.53,
    y1: 112.99,
    x2: 157.23,
    y2: 113.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 156.26,
    y1: 114.27,
    x2: 154.95,
    y2: 115
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 153.98,
    y1: 115.54,
    x2: 152.67,
    y2: 116.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.7,
    y1: 116.82,
    x2: 150.4,
    y2: 117.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 149.42,
    y1: 118.1,
    x2: 148.12,
    y2: 118.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 147.14,
    y1: 119.37,
    x2: 145.84,
    y2: 120.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 144.86,
    y1: 120.65,
    x2: 143.56,
    y2: 121.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.58,
    y1: 121.93,
    x2: 141.28,
    y2: 122.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 140.3,
    y1: 123.2,
    x2: 139,
    y2: 123.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 138.03,
    y1: 124.48,
    x2: 136.72,
    y2: 125.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.75,
    y1: 125.76,
    x2: 134.44,
    y2: 126.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 133.47,
    y1: 127.03,
    x2: 132.17,
    y2: 127.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 131.19,
    y1: 128.31,
    x2: 129.89,
    y2: 129.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 128.91,
    y1: 129.59,
    x2: 127.61,
    y2: 130.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 126.63,
    y1: 130.86,
    x2: 125.33,
    y2: 131.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 124.35,
    y1: 132.14,
    x2: 123.05,
    y2: 132.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 122.07,
    y1: 133.42,
    x2: 120.77,
    y2: 134.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 119.8,
    y1: 134.69,
    x2: 118.49,
    y2: 135.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 117.52,
    y1: 135.97,
    x2: 116.21,
    y2: 136.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 115.24,
    y1: 137.25,
    x2: 113.94,
    y2: 137.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 112.96,
    y1: 138.52,
    x2: 111.66,
    y2: 139.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 110.68,
    y1: 139.8,
    x2: 109.38,
    y2: 140.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 108.4,
    y1: 141.07,
    x2: 107.1,
    y2: 141.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 106.12,
    y1: 142.35,
    x2: 104.82,
    y2: 143.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 103.84,
    y1: 143.63,
    x2: 102.54,
    y2: 144.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 101.57,
    y1: 144.9,
    x2: 100.26,
    y2: 145.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 99.29,
    y1: 146.18,
    x2: 98.15,
    y2: 146.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 164.91,
    y1: 97.69,
    x2: 163.77,
    y2: 98.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 162.79,
    y1: 98.88,
    x2: 161.49,
    y2: 99.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 160.51,
    y1: 100.15,
    x2: 159.21,
    y2: 100.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 158.23,
    y1: 101.43,
    x2: 156.93,
    y2: 102.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 155.95,
    y1: 102.71,
    x2: 154.65,
    y2: 103.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 153.68,
    y1: 103.98,
    x2: 152.37,
    y2: 104.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.4,
    y1: 105.26,
    x2: 150.09,
    y2: 105.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 149.12,
    y1: 106.54,
    x2: 147.82,
    y2: 107.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 146.84,
    y1: 107.81,
    x2: 145.54,
    y2: 108.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 144.56,
    y1: 109.09,
    x2: 143.26,
    y2: 109.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.28,
    y1: 110.37,
    x2: 140.98,
    y2: 111.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 140,
    y1: 111.64,
    x2: 138.7,
    y2: 112.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 137.72,
    y1: 112.92,
    x2: 136.42,
    y2: 113.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.45,
    y1: 114.2,
    x2: 134.14,
    y2: 114.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 133.17,
    y1: 115.47,
    x2: 131.86,
    y2: 116.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 130.89,
    y1: 116.75,
    x2: 129.59,
    y2: 117.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 128.61,
    y1: 118.03,
    x2: 127.31,
    y2: 118.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 126.33,
    y1: 119.3,
    x2: 125.03,
    y2: 120.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 124.05,
    y1: 120.58,
    x2: 122.75,
    y2: 121.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 121.77,
    y1: 121.86,
    x2: 120.47,
    y2: 122.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 119.49,
    y1: 123.13,
    x2: 118.19,
    y2: 123.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 117.21,
    y1: 124.41,
    x2: 115.91,
    y2: 125.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.94,
    y1: 125.69,
    x2: 113.63,
    y2: 126.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 112.66,
    y1: 126.96,
    x2: 111.36,
    y2: 127.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 110.38,
    y1: 128.24,
    x2: 109.08,
    y2: 128.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 108.1,
    y1: 129.52,
    x2: 106.8,
    y2: 130.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 105.82,
    y1: 130.79,
    x2: 104.52,
    y2: 131.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 103.54,
    y1: 132.07,
    x2: 102.4,
    y2: 132.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 164.91,
    y1: 95.14,
    x2: 163.77,
    y2: 95.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 162.79,
    y1: 96.33,
    x2: 161.49,
    y2: 97.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 160.51,
    y1: 97.61,
    x2: 159.21,
    y2: 98.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 158.23,
    y1: 98.88,
    x2: 156.93,
    y2: 99.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 155.95,
    y1: 100.16,
    x2: 154.65,
    y2: 100.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 153.68,
    y1: 101.44,
    x2: 152.37,
    y2: 102.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.4,
    y1: 102.71,
    x2: 150.09,
    y2: 103.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 149.12,
    y1: 103.99,
    x2: 147.82,
    y2: 104.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 146.84,
    y1: 105.27,
    x2: 145.54,
    y2: 105.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 144.56,
    y1: 106.54,
    x2: 143.26,
    y2: 107.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.28,
    y1: 107.82,
    x2: 140.98,
    y2: 108.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 140,
    y1: 109.09,
    x2: 138.7,
    y2: 109.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 137.72,
    y1: 110.37,
    x2: 136.42,
    y2: 111.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.45,
    y1: 111.65,
    x2: 134.14,
    y2: 112.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 133.17,
    y1: 112.92,
    x2: 131.86,
    y2: 113.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 130.89,
    y1: 114.2,
    x2: 129.59,
    y2: 114.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 128.61,
    y1: 115.48,
    x2: 127.31,
    y2: 116.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 126.33,
    y1: 116.75,
    x2: 125.03,
    y2: 117.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 124.05,
    y1: 118.03,
    x2: 122.75,
    y2: 118.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 121.77,
    y1: 119.31,
    x2: 120.47,
    y2: 120.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 119.49,
    y1: 120.58,
    x2: 118.19,
    y2: 121.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 117.21,
    y1: 121.86,
    x2: 115.91,
    y2: 122.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.94,
    y1: 123.14,
    x2: 113.63,
    y2: 123.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 112.66,
    y1: 124.41,
    x2: 111.36,
    y2: 125.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 110.38,
    y1: 125.69,
    x2: 109.08,
    y2: 126.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 108.1,
    y1: 126.97,
    x2: 106.8,
    y2: 127.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 105.82,
    y1: 128.24,
    x2: 104.52,
    y2: 128.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 103.54,
    y1: 129.52,
    x2: 102.4,
    y2: 130.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 164.91,
    y1: 115.88,
    x2: 163.77,
    y2: 116.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 162.79,
    y1: 117.07,
    x2: 161.49,
    y2: 117.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 160.51,
    y1: 118.35,
    x2: 159.21,
    y2: 119.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 158.23,
    y1: 119.62,
    x2: 156.93,
    y2: 120.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 155.95,
    y1: 120.9,
    x2: 154.65,
    y2: 121.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 153.68,
    y1: 122.18,
    x2: 152.37,
    y2: 122.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.4,
    y1: 123.45,
    x2: 150.09,
    y2: 124.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 149.12,
    y1: 124.73,
    x2: 147.82,
    y2: 125.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 146.84,
    y1: 126.01,
    x2: 145.54,
    y2: 126.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 144.56,
    y1: 127.28,
    x2: 143.26,
    y2: 128.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.28,
    y1: 128.56,
    x2: 140.98,
    y2: 129.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 140,
    y1: 129.84,
    x2: 138.7,
    y2: 130.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 137.72,
    y1: 131.11,
    x2: 136.42,
    y2: 131.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.45,
    y1: 132.39,
    x2: 134.14,
    y2: 133.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 133.17,
    y1: 133.67,
    x2: 131.86,
    y2: 134.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 130.89,
    y1: 134.94,
    x2: 129.59,
    y2: 135.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 128.61,
    y1: 136.22,
    x2: 127.31,
    y2: 136.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 126.33,
    y1: 137.5,
    x2: 125.03,
    y2: 138.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 124.05,
    y1: 138.77,
    x2: 122.75,
    y2: 139.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 121.77,
    y1: 140.05,
    x2: 120.47,
    y2: 140.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 119.49,
    y1: 141.33,
    x2: 118.19,
    y2: 142.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 117.21,
    y1: 142.6,
    x2: 115.91,
    y2: 143.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.94,
    y1: 143.88,
    x2: 113.63,
    y2: 144.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 112.66,
    y1: 145.16,
    x2: 111.36,
    y2: 145.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 110.38,
    y1: 146.43,
    x2: 109.08,
    y2: 147.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 108.1,
    y1: 147.71,
    x2: 106.8,
    y2: 148.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 105.82,
    y1: 148.99,
    x2: 104.52,
    y2: 149.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 103.54,
    y1: 150.26,
    x2: 102.4,
    y2: 150.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 14.68,
    y1: 116.77,
    x2: 14.68,
    y2: 119.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 14.68,
    y1: 119.32,
    x2: 16.51,
    y2: 119.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.73,
    y1: 120.42,
    x2: 19.56,
    y2: 121.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.56,
    y1: 100.34,
    x2: 17.73,
    y2: 99.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 16.51,
    y1: 99.24,
    x2: 14.68,
    y2: 98.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 14.68,
    y1: 98.58,
    x2: 14.68,
    y2: 101.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 14.68,
    y1: 101.13,
    x2: 16.2,
    y2: 101.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.42,
    y1: 102.12,
    x2: 18.94,
    y2: 102.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18.94,
    y1: 102.66,
    x2: 18.94,
    y2: 104.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18.94,
    y1: 106.3,
    x2: 18.94,
    y2: 108.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18.94,
    y1: 109.55,
    x2: 18.94,
    y2: 111.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18.94,
    y1: 112.81,
    x2: 18.94,
    y2: 114.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18.94,
    y1: 116.07,
    x2: 18.94,
    y2: 118.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18.94,
    y1: 118.31,
    x2: 17.42,
    y2: 117.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 16.2,
    y1: 117.32,
    x2: 14.68,
    y2: 116.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 77.19,
    y1: 63.57,
    x2: 79.01,
    y2: 64.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.23,
    y1: 64.66,
    x2: 82.06,
    y2: 65.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18.94,
    y1: 114.39,
    x2: 17.3,
    y2: 115.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 16.32,
    y1: 115.86,
    x2: 14.68,
    y2: 116.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 14.68,
    y1: 98.58,
    x2: 15.82,
    y2: 97.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 16.8,
    y1: 97.4,
    x2: 18.1,
    y2: 96.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.08,
    y1: 96.12,
    x2: 20.38,
    y2: 95.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.36,
    y1: 94.84,
    x2: 22.66,
    y2: 94.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.64,
    y1: 93.57,
    x2: 24.94,
    y2: 92.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 25.91,
    y1: 92.29,
    x2: 27.22,
    y2: 91.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 28.19,
    y1: 91.01,
    x2: 29.5,
    y2: 90.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 30.47,
    y1: 89.74,
    x2: 31.77,
    y2: 89.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 32.75,
    y1: 88.46,
    x2: 34.05,
    y2: 87.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 35.03,
    y1: 87.18,
    x2: 36.33,
    y2: 86.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 37.31,
    y1: 85.91,
    x2: 38.61,
    y2: 85.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 39.59,
    y1: 84.63,
    x2: 40.89,
    y2: 83.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 41.87,
    y1: 83.35,
    x2: 43.17,
    y2: 82.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44.14,
    y1: 82.08,
    x2: 45.45,
    y2: 81.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 46.42,
    y1: 80.8,
    x2: 47.73,
    y2: 80.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.7,
    y1: 79.52,
    x2: 50,
    y2: 78.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 50.98,
    y1: 78.25,
    x2: 52.28,
    y2: 77.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.26,
    y1: 76.97,
    x2: 54.56,
    y2: 76.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 55.54,
    y1: 75.69,
    x2: 56.84,
    y2: 74.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 57.82,
    y1: 74.42,
    x2: 59.12,
    y2: 73.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 60.1,
    y1: 73.14,
    x2: 61.4,
    y2: 72.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 62.37,
    y1: 71.86,
    x2: 63.68,
    y2: 71.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 64.65,
    y1: 70.59,
    x2: 65.96,
    y2: 69.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 66.93,
    y1: 69.31,
    x2: 68.23,
    y2: 68.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 69.21,
    y1: 68.03,
    x2: 70.51,
    y2: 67.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 71.49,
    y1: 66.76,
    x2: 72.79,
    y2: 66.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 73.77,
    y1: 65.48,
    x2: 75.07,
    y2: 64.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.05,
    y1: 64.2,
    x2: 77.19,
    y2: 63.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.35,
    y1: 83.32,
    x2: 65.97,
    y2: 58.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 65.97,
    y1: 58.89,
    x2: 63.5,
    y2: 63.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 24.82,
    y1: 78.78,
    x2: 22.35,
    y2: 83.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 93.56,
    y1: 55.89,
    x2: 139.66,
    y2: 72.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 136.41,
    y1: 71.32,
    x2: 133.48,
    y2: 71.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 136.41,
    y1: 71.32,
    x2: 139.34,
    y2: 71.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 136.41,
    y1: 71.32,
    x2: 139.01,
    y2: 69.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 136.41,
    y1: 71.32,
    x2: 124.27,
    y2: 78.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 96.81,
    y1: 57.06,
    x2: 93.88,
    y2: 57.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 96.81,
    y1: 57.06,
    x2: 99.73,
    y2: 56.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 96.81,
    y1: 57.06,
    x2: 99.41,
    y2: 55.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 96.81,
    y1: 57.06,
    x2: 84.66,
    y2: 63.86
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.97 65.17 117.61 65.65 118.4 65.54 118.88 64.9 118.77 64.11 118.13 63.63 117.34 63.74 116.86 64.38 116.97 65.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "116.97 65.17 117.61 65.65 118.4 65.54 118.88 64.9 118.77 64.11 118.13 63.63 117.34 63.74 116.86 64.38 116.97 65.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "116.97 65.17 117.61 65.65 118.4 65.54 118.88 64.9 118.77 64.11 118.13 63.63 117.34 63.74 116.86 64.38 116.97 65.17"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 155.8,
    y1: 42.35,
    x2: 172.32,
    y2: 42.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 117.87,
    y1: 64.64,
    x2: 155.8,
    y2: 42.35
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(175.44 45.47)"
  }, "Intermediate "), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(175.44 55.54)"
  }, "Member Spacing"), /*#__PURE__*/React.createElement("polygon", {
    points: "95.65 145.88 94.91 145.6 94.18 145.93 93.9 146.68 94.23 147.4 94.98 147.68 95.7 147.35 95.98 146.6 95.65 145.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "95.65 145.88 94.91 145.6 94.18 145.93 93.9 146.68 94.23 147.4 94.98 147.68 95.7 147.35 95.98 146.6 95.65 145.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "95.65 145.88 94.91 145.6 94.18 145.93 93.9 146.68 94.23 147.4 94.98 147.68 95.7 147.35 95.98 146.6 95.65 145.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 77.63,
    y1: 165.22,
    x2: 88.44,
    y2: 165.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 94.94,
    y1: 146.64,
    x2: 77.63,
    y2: 165.22
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(91.56 168.34)"
  }, "Note: only half of each edge member "), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(91.56 178.4)"
  }, "will count toward GWP. It is assumed "), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(91.56 188.46)"
  }, "that the module will repeat adjacent."), /*#__PURE__*/React.createElement("polygon", {
    points: "45.31 70.89 46.1 70.9 46.67 70.33 46.67 69.54 46.11 68.97 45.31 68.97 44.75 69.53 44.75 70.33 45.31 70.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "45.31 70.89 46.1 70.9 46.67 70.33 46.67 69.54 46.11 68.97 45.31 68.97 44.75 69.53 44.75 70.33 45.31 70.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "45.31 70.89 46.1 70.9 46.67 70.33 46.67 69.54 46.11 68.97 45.31 68.97 44.75 69.53 44.75 70.33 45.31 70.89"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 71.1,
    y1: 9.09,
    x2: 90.61,
    y2: 9.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 45.71,
    y1: 69.93,
    x2: 71.1,
    y2: 9.09
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(93.74 12.21)"
  }, "Span Direction, relative to module "), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(93.74 22.27)"
  }, "dimensions.")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFramingLayer);
export default __webpack_public_path__ + "static/media/IconFramingLayer.91a10e9a6b515484d4a1d247fefd61a1.svg";
export { ForwardRef as ReactComponent };